module.exports = __webpack_public_path__ + "img/slide-offer202402-dt-gr.ebfb093d.png";